import React from "react";
import isEqual from "lodash/isEqual";
import styled from "styled-components";
import { tableCss } from "components/bootstrap/Table";
import Filter from "./Filter";
import DataTableElement from "./DataTableElement";
import NoEntitiesExist from "../NoEntitiesExist";
const StyledTable = styled.table`
  ${tableCss}
`;
const NoData = ({ noDataText }) => {
  if (typeof noDataText === "string") {
    return /* @__PURE__ */ React.createElement(NoEntitiesExist, null, noDataText);
  }
  return noDataText;
};
class DataTable extends React.Component {
  constructor(props) {
    super(props);
    this.getFormattedHeaders = () => {
      let i = 0;
      const { headerCellFormatter, headers } = this.props;
      const formattedHeaders = headers.map((header) => {
        const el = /* @__PURE__ */ React.createElement(DataTableElement, { key: `header-${i}`, element: header, index: i, formatter: headerCellFormatter });
        i += 1;
        return el;
      });
      return /* @__PURE__ */ React.createElement("tr", null, formattedHeaders);
    };
    this.getFormattedDataRows = () => {
      let i = 0;
      const { sortByKey, sortBy, dataRowFormatter, useNumericSort } = this.props;
      let sortedDataRows = this._getEffectiveRows();
      if (sortByKey || sortBy) {
        const sortValue = sortByKey ? (row) => row[sortByKey] : sortBy;
        sortedDataRows = sortedDataRows.sort(
          (a, b) => {
            var _a, _b;
            return String((_a = sortValue(a)) != null ? _a : "").localeCompare(String((_b = sortValue(b)) != null ? _b : ""), void 0, { numeric: useNumericSort });
          }
        );
      }
      const formattedDataRows = sortedDataRows.map((row) => {
        const el = /* @__PURE__ */ React.createElement(DataTableElement, { key: `row-${i}`, element: row, index: i, formatter: dataRowFormatter });
        i += 1;
        return el;
      });
      return formattedDataRows;
    };
    this.filterDataRows = (filteredRows) => {
      this.setState({ filteredRows });
    };
    this._getEffectiveRows = () => {
      const { filteredRows } = this.state;
      const { filterKeys, rows } = this.props;
      return filterKeys.length === 0 ? rows : filteredRows.filter((row) => rows.some((r) => isEqual(r, row)));
    };
    const { rows } = this.props;
    this.state = {
      filteredRows: rows
    };
  }
  render() {
    const {
      customFilter,
      filterKeys,
      id,
      filterLabel,
      children,
      noDataText,
      className,
      rowClassName,
      useResponsiveTable,
      rows
    } = this.props;
    const effectiveRows = this._getEffectiveRows();
    let data;
    if (rows.length === 0) {
      data = /* @__PURE__ */ React.createElement(NoData, { noDataText });
    } else if (effectiveRows.length === 0) {
      data = /* @__PURE__ */ React.createElement("p", null, "Filter does not match any data.");
    } else {
      data = /* @__PURE__ */ React.createElement(StyledTable, { className: `table ${className != null ? className : ""}` }, /* @__PURE__ */ React.createElement("thead", null, this.getFormattedHeaders()), /* @__PURE__ */ React.createElement("tbody", null, this.getFormattedDataRows()));
    }
    return /* @__PURE__ */ React.createElement("div", null, customFilter || /* @__PURE__ */ React.createElement(Filter, { label: filterLabel, rows, id, filterKeys, onDataFiltered: this.filterDataRows }, children), /* @__PURE__ */ React.createElement("div", { className: `row ${rowClassName}` }, /* @__PURE__ */ React.createElement("div", { className: "col-md-12" }, /* @__PURE__ */ React.createElement("div", { id, className: `data-table ${useResponsiveTable ? "table-responsive" : ""}` }, data))));
  }
}
DataTable.defaultProps = {
  customFilter: void 0,
  children: void 0,
  className: "",
  filterKeys: [],
  filterLabel: "Filter",
  noDataText: "No data available.",
  rowClassName: "",
  useResponsiveTable: true,
  // eslint-disable-next-line react/no-unstable-nested-components
  headerCellFormatter: (header) => /* @__PURE__ */ React.createElement("th", null, header),
  sortByKey: void 0,
  sortBy: void 0,
  useNumericSort: false
};
export default DataTable;
